import {
  EResearchBudgetLimit,
  EResearchSearchCondition,
} from "../../types/chat";
import type { TDeepResearchKey } from "./types";

// NOTE: NSAI-6435 — host badges on the Activity button, and source chips
// under one search in the activity list.
export const DEEP_RESEARCH_BUTTON_HOST_COUNT = 3;
export const DEEP_RESEARCH_ITEM_HOST_COUNT = 4;

// NOTE: NSAI-7335 — how far from the end of the Activity list still counts as
// the end: rounding of a fractional scroll offset, not a scroll up.
export const DEEP_RESEARCH_ACTIVITY_END_TOLERANCE_PX = 4;

// NOTE: Host badge colours: saturated enough to carry a white initial in
// both themes.
export const DEEP_RESEARCH_HOST_COLORS = [
  "#0F766E",
  "#1D4ED8",
  "#B45309",
  "#7C3AED",
  "#BE185D",
  "#047857",
  "#9333EA",
  "#C2410C",
] as const;

// NOTE: The query statuses the server writes for a search or topic.
export const DEEP_RESEARCH_ENTRY_STATUS = {
  PENDING: "pending",
  RESEARCHING: "researching",
  COMPLETED: "completed",
  ERROR: "error",
  CANCELLED: "cancelled",
} as const;

// NOTE: The live progress status of a run that failed.
export const DEEP_RESEARCH_ERROR_STATUS = "error";

export const DEEP_RESEARCH_MS_PER_SECOND = 1_000;
export const DEEP_RESEARCH_SECONDS_PER_MINUTE = 60;
export const DEEP_RESEARCH_MINUTES_PER_HOUR = 60;

// NOTE: The note a finished run carries for what limited it.
export const DEEP_RESEARCH_LIMIT_NOTE_KEYS: Record<
  EResearchBudgetLimit,
  TDeepResearchKey
> = {
  [EResearchBudgetLimit.TIME]: "deep_research.limit.time",
  [EResearchBudgetLimit.TOKENS]: "deep_research.limit.tokens",
  [EResearchBudgetLimit.ROUNDS]: "deep_research.limit.rounds",
};

export const DEEP_RESEARCH_CONDITION_NOTE_KEYS: Record<
  EResearchSearchCondition,
  TDeepResearchKey
> = {
  [EResearchSearchCondition.QUOTA_EXHAUSTED]:
    "deep_research.condition.quota_exhausted",
  [EResearchSearchCondition.PROVIDER_UNREACHABLE]:
    "deep_research.condition.provider_unreachable",
};
